import { convertToFormData } from "helper/convert_obj_to_form_data";
import client from "./config";

//////////////// advs ////////////////
const url = "advs/";
export const getAdvsRequest = (values) => {
  !values.search && delete values.search;
  return client.get(url, values);
};

export const getAdvByIdRequest = (values) => client.get(`${url}${values}`);

export const addNewAdvRequest = (values, onUploadProgress) => {
  return client.post(url, convertToFormData(values), {
      onUploadProgress: (progress) =>
        onUploadProgress((progress.loaded / progress.total) * 100),
    });
}

export const updateAdvByIdRequest = (values, onUploadProgress) => {
  return client.put(`${url}${values.id}`, convertToFormData(values), {
      onUploadProgress: (progress) =>
        onUploadProgress((progress.loaded / progress.total) * 100),
    });
}


export const deleteAdvByIdRequest = (values) => client.delete(`${url}${values}`);

export const deleteAdvFilesByIdRequest = (values) => client.put(`${url}${values.id}`, values);
